import React from 'react';
import OpenInNew from '@mui/icons-material/OpenInNew';
import { colors } from '../../../colors';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

interface Props {
  claimId: number;
  number: string;
}

const path = '/claimorders?claimId=';

const getHostName = () => {
  const hostname = window.location.hostname;
  if (hostname.startsWith('conveneportal.dev') || hostname === 'localhost') {
    return process.env.REACT_APP_LEAP_HOST_NAME_DEV;
  }

  if (hostname.startsWith('conveneportal.qa')) {
    return process.env.REACT_APP_LEAP_HOST_NAME_STG;
  }

  return process.env.REACT_APP_LEAP_HOST_NAME_PROD;
};

export default function ExternalLinkToInvoice(props: Props) {
  return (
    <Typography
      sx={{
        margin: '-2px 0 0 0',
        color: colors.black,
        fontFamily: (theme) => theme.typography.fontFamily,
        fontSize: '15px',
        fontWeight: 'bold',
        textDecoration: 'none'
      }}>
      {props.number}
      <Link
        href={`${getHostName()}${path}${props.claimId}`}
        rel="noreferrer"
        target="_blank"
      >
        <OpenInNew sx={{
          fontSize: '14px',
          marginLeft: '4px',
          verticalAlign: 'text-bottom',
          width: '1.2em',
          height: '1.2em'
        }}>
        </OpenInNew>
      </Link>
    </Typography>
  )
};
